import { accessGroupContent } from "./access_groups/accessGroupContent";
import { accessGroupMembers } from "./access_groups/accessGroupMembers";
import { accessGroupSources } from "./access_groups/accessGroupSources";
import { accessGroups } from "./access_groups/accessGroups";
import { communityMemberPaymentMethods } from "./communityMemberPaymentMethods";
import { connections } from "./connect/connections";
import { connectSettings } from "./connect/settings";
import { paywalls } from "./paywalls";
import { search } from "./search";

export const admin = {
  search,
  paywalls,
  communityMemberPaymentMethods,
  accessGroups,
  accessGroupMembers,
  accessGroupContent,
  accessGroupSources,
  connectSettings,
  connections,
};
